import { useDispatch, useSelector } from 'react-redux';
import { currentWeekSlice } from './slice';

export const useCurrentWeek = () => {
  const dispatch = useDispatch();

  const currentWeek = useSelector(
    (state: any) => state.currentWeek.currentWeek as Date[],
  );

  const handleSetCurrentWeek = (newDates: Date[]) => {
    dispatch(currentWeekSlice.actions.setCurrentWeek(newDates));
  };

  return [currentWeek, handleSetCurrentWeek] as const;
};

export const currentWeekReducer = currentWeekSlice.reducer;
